import React from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import WorkoutHistory from "./WorkoutHistory";
import ClientWorkoutPreference from "./ClientWorkoutPreference";
import ClientWorkoutPlan from "./ClientWorkoutPlan";
import ClientInfoTab from "./ClientInfoTab";
import { useSelector } from "react-redux";
import { useState } from "react";
import ClientPaymentDetailsTab from "./ClientPaymentDetailsTab";
import ClientMealsDetails from "./ClientMealsDetails";
import { CONSTANTS } from "../../utils/Constant/Constant";
import useCustomTranslation from "../../hooks/useCustomTranslation";

function ClientWorkoutTab({ selectedClientId, type, status, clientDetails }) {
  const { trans } = useCustomTranslation();
  const [activeTab, setActiveTab] = useState(type || "Meals");
  const { profileData } = useSelector((state) => state.profile);
  const coachId = profileData?.coachId;
  const handleSelect = (key) => {
    setActiveTab(key);
  };

  return (
    <div>
      <Tabs
        activeKey={activeTab}
        onSelect={handleSelect}
        id="controlled-tab-example"
        className="fs-5 mx-5 alligntop"
      >
        <Tab
          eventKey={CONSTANTS.MEALS}
          title={trans("ClientOverviewTab.meals")}
        >
          <ClientMealsDetails
            coachId={coachId}
            clientId={selectedClientId}
            status={status}
          />
        </Tab>
        <Tab
          eventKey={CONSTANTS.WORKOUT}
          title={trans("ClientOverviewTab.workout")}
        >
          {activeTab === CONSTANTS.WORKOUT && (
            <div className="client-left-bar">
              <WorkoutHistory
                selectedCoachId={coachId}
                selectedClientId={selectedClientId}
              />
              <ClientWorkoutPreference
                selectedCoachId={coachId}
                selectedClientId={selectedClientId}
                status={status}
              />
              <ClientWorkoutPlan
                selectedCoachId={coachId}
                selectedClientId={selectedClientId}
                status={status}
                clientDetails={clientDetails}
              />
            </div>
          )}
        </Tab>
        <Tab
          eventKey={CONSTANTS.PAYMENT}
          title={trans("ClientOverviewTab.payment")}
        >
          {activeTab === CONSTANTS.PAYMENT && (
            <ClientPaymentDetailsTab
              coachId={coachId}
              selectedClientId={selectedClientId}
              status={status}
            />
          )}
        </Tab>
        <Tab eventKey={CONSTANTS.INFO} title={trans("ClientOverviewTab.info")}>
          {activeTab === CONSTANTS.INFO && (
            <ClientInfoTab
              selectedClientId={selectedClientId}
              status={status}
            />
          )}
        </Tab>
      </Tabs>
    </div>
  );
}

export default ClientWorkoutTab;
